// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a9089d49","452":"edf085fb","455":"b7a3a1a1"}[chunkId] + ".chunk.js";
};